import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100">
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          {/* Logo/Brand Section */}
          <div className="text-center">
            <h1 className="text-4xl font-bold text-primary-600 mb-2">
              The Daily Do
            </h1>
            <p className="text-gray-600">
              Discover amazing local events
            </p>
          </div>
          
          {/* Auth Content */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            {children}
          </div>
          
          {/* Footer */}
          <div className="text-center text-sm text-gray-500">
            <p>&copy; 2024 The Daily Do. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}